var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAttachments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 153.82,
    height: 168.692,
    viewBox: "0 0 153.82 168.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1244",
    "data-name": "Rectangle 1244",
    width: 47.226,
    height: 67.608,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Attached_files-bro",
    "data-name": "Attached files-bro",
    transform: "translate(-186.113 -95.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2",
    transform: "translate(186.113 95.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8301",
    "data-name": "Path 8301",
    d: "M203.87,114.134c-7.015-7.759-18.769-8.626-27.908-13.713-15.73-8.754-21.827-28.687-36.137-39.608-9.024-6.9-21.244-9.567-32.161-8.056C92.165,54.9,77.585,65.291,73.208,80.523a38.482,38.482,0,0,0-1.327,13.655c.7,9.081,2.653,18.279.81,27.2-2.032,9.83-8.426,18.124-12.248,27.414-4.759,11.569-5.4,24.526-3.382,36.858,1.388,8.414,4.157,16.91,9.934,23.18.44.474.891.926,1.357,1.369,0,0,14.7,10.843,30.468,10.843S131.441,210.2,131.441,210.2c3.957-5.048,6.941-11.021,10.439-16.324,8.761-13.335,22.791-22.844,38.112-27.306,6.864-2,14.3-3.185,19.814-7.736,5.676-4.678,8.283-12.143,9.409-19.412C210.584,130.6,209.855,120.74,203.87,114.134Z",
    transform: "translate(-55.983 -52.348)",
    fill: "#d1e9fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(198.59 122.685)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1241",
    "data-name": "Rectangle 1241",
    width: 94.723,
    height: 107.733,
    rx: 5.95,
    fill: "#64b5f6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1242",
    "data-name": "Rectangle 1242",
    width: 47.226,
    height: 67.608,
    transform: "translate(20.715 23.644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1392",
    "data-name": "Group 1392",
    transform: "translate(20.715 23.644)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1243",
    "data-name": "Rectangle 1243",
    width: 47.226,
    height: 67.608,
    fill: "#64b5f6",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1245",
    "data-name": "Rectangle 1245",
    width: 47.226,
    height: 67.608,
    transform: "translate(20.715 23.644)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1246",
    "data-name": "Rectangle 1246",
    width: 47.226,
    height: 67.608,
    transform: "translate(20.081 23.342) rotate(-11.29)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8305",
    "data-name": "Path 8305",
    d: "M261.38,125.231a4.591,4.591,0,0,1,4.234-2.831h0a4.566,4.566,0,0,1,4.566,4.566v9.526a3.052,3.052,0,0,1-3.04,3.052h0a3.052,3.052,0,0,1-3.052-3.052v-9.046a1.428,1.428,0,0,1,1.428-1.428h0a1.428,1.428,0,0,1,1.428,1.428v4.862",
    transform: "translate(-237.835 -102.916)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_558",
    "data-name": "Line 558",
    y1: 3.668,
    x2: 18.413,
    transform: "translate(37.035 64.741)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_559",
    "data-name": "Line 559",
    y1: 6.4,
    x2: 32.063,
    transform: "translate(36.161 57.319)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_560",
    "data-name": "Line 560",
    y1: 6.4,
    x2: 32.05,
    transform: "translate(35.3 52.629)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_561",
    "data-name": "Line 561",
    y1: 6.4,
    x2: 32.05,
    transform: "translate(34.426 47.94)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_562",
    "data-name": "Line 562",
    y1: 6.4,
    x2: 32.05,
    transform: "translate(33.552 43.238)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_563",
    "data-name": "Line 563",
    y1: 6.4,
    x2: 32.05,
    transform: "translate(32.678 38.549)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_564",
    "data-name": "Line 564",
    y1: 6.4,
    x2: 32.05,
    transform: "translate(31.804 33.86)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_565",
    "data-name": "Line 565",
    y1: 4.689,
    x2: 23.496,
    transform: "translate(39.484 29.17)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAttachments);
export default __webpack_public_path__ + "static/media/no_attachments.2020850fa3cafada514e8e8ba7e8224f.svg";
export { ForwardRef as ReactComponent };